/*
  Leventh PDP v2 - shared carousel
  ---------------------------------------------------------------------------
  Used by leventh-pdp-progress and leventh-pdp-social. Both sections load this
  file with a deferred script tag; two tags with the same href are fetched only
  ONCE by the browser, so this costs no extra request.

  Scrolling itself is handled by CSS scroll-snap. This file does two things
  only:
    - clicking a dot jumps to the matching slide
    - whichever slide is in view gets its dot highlighted

  No setInterval, no polling (core 4.5). Dot clicks are caught with event
  delegation on the root. Calling initAll any number of times never doubles a
  handler thanks to the dataset.leventhCarouselReady flag (core 4.4). The
  observer is disconnected on shopify:section:unload (core 4.4, T1.13).

  Required markup:
    [data-leventh-carousel]              root
      [data-leventh-carousel-track]      scrolling area
      [data-leventh-carousel-slide]      each slide
      [data-leventh-carousel-dot]        each dot, must be a button element
*/
(function () {
  var ROOT = '[data-leventh-carousel]';
  var observers = new WeakMap();
  // core 7.8: a dot click must not animate for a reader who asked for less
  // motion. Queried once at module scope; matchMedia stays live on its own.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function teardown(root) {
    var observer = observers.get(root);
    if (observer) {
      observer.disconnect();
      observers.delete(root);
    }
    delete root.dataset.leventhCarouselReady;
  }

  function init(root) {
    if (!root || root.dataset.leventhCarouselReady === 'true') return;

    var track = root.querySelector('[data-leventh-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-leventh-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-leventh-carousel-dot]'));
    if (!track || slides.length === 0 || dots.length === 0) return;

    root.dataset.leventhCarouselReady = 'true';

    function setActive(index) {
      for (var i = 0; i < dots.length; i++) {
        var on = i === index;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var dot = target.closest('[data-leventh-carousel-dot]');
      if (!dot || !root.contains(dot)) return;
      var index = dots.indexOf(dot);
      if (index < 0 || !slides[index]) return;
      track.scrollTo({
        left: slides[index].offsetLeft - slides[0].offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    });

    if (typeof IntersectionObserver !== 'function') {
      setActive(0);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) setActive(slides.indexOf(entries[i].target));
        }
      },
      { root: track, threshold: 0.6 }
    );

    for (var s = 0; s < slides.length; s++) observer.observe(slides[s]);
    observers.set(root, observer);
    setActive(0);

    enableDrag(track);
  }

  // Drag with a mouse. A scroll-snap track scrolls with a touch or a trackpad
  // but a mouse can only reach it through the scrollbar, so on desktop the
  // carousel looked frozen. Pointer events cover mouse, pen and touch in one
  // path; touch keeps its native scrolling because we only take over for a
  // non-touch pointer.
  function enableDrag(track) {
    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth + 4) return;
      down = true;
      moved = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      // Snapping fights a drag in progress: it keeps pulling the track back to
      // the nearest slide while the pointer is still down.
      track.style.scrollSnapType = 'none';
      track.style.cursor = 'grabbing';
    });

    track.addEventListener('pointermove', function (event) {
      if (!down) return;
      var dx = event.clientX - startX;
      if (!moved && Math.abs(dx) > 3) {
        moved = true;
        // Capture keeps the drag alive when the pointer leaves the track. It
        // throws if the id is not an active pointer, which happens with a
        // synthetic event, and that must not stop the scroll below.
        try {
          track.setPointerCapture(event.pointerId);
        } catch (e) {}
      }
      if (!moved) return;
      event.preventDefault();
      track.scrollLeft = startScroll - dx;
    });

    function end(event) {
      if (!down) return;
      down = false;
      track.style.scrollSnapType = '';
      track.style.cursor = '';
      if (event && event.pointerId !== undefined && track.hasPointerCapture &&
          track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);

    // A drag that ends on top of a link must not also follow that link.
    track.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) teardown(roots[i]);
  });
})();
